import { PaymentSection } from "../payment/PaymentSection";
import { InstalmentSection } from "../payment/InstalmentSection";
import { useEffect, useState } from "react";
import { PendingDelivery } from "../PendingDelivery";

export const Signature = ({ onCompletion, currentSubStep, data, setCurrentStep }) => {
    const [paymentData, setPaymentData] = useState();

    useEffect(() => {
        if (data) {
            const VAT = data.VATTax;
            const paymentObj = {
                amountInitRent : data.initialDeposit * VAT || 0,
                amountWarranty : data.guaranteesAmount || 0,
                extraChargesVAT : data.extraCharges * VAT || 0,
            }
            setPaymentData(paymentObj)
        }
    },[data])

  

    return(
        <div className="lg:left-[400px] pt-10 absolute top-0 w-full lg:w-[calc(100vw-500px)] max-lg:p-2 max-lg:pb-[150px]">
            {
                currentSubStep === 1 ? <PaymentSection paymentData={paymentData} setCurrentStep={setCurrentStep} /> :
                currentSubStep === 2 ? <InstalmentSection onCompletion={onCompletion} /> :
                        <PendingDelivery state={data.state} />
            }
        </div>
    )
}